<div class="list-wrapper">
  <div class="list-header">{{ "network" | translate }}</div>
  <div class="border-bottom-gray"></div>
  <div class="scrollBar">
    @for (network of availableNetworks; track network) {
      <div>
        <div class="row-wrapper">
          <button (click)="selectNetwork(network.id, network.name)" class="item-wrapper">
            <img [src]="network.logo" alt="network logo" width="40" />
            <div class="network-name">{{ "name_network" | translate: [network.name] }}</div>
            @if (network.withdrawal_disclaimer && networkDisclaimer > 0) {
              <div class="poly-disclaimer">
                <div [innerHTML]="networkDisclaimer"></div>
                <div [actionButtonName]="'more_information' | translate"
                  (onActionButtonClicked)="tooltipActionButtonClicked(network.withdrawal_disclaimer_link)"
                  [tooltip]="network.withdrawal_disclaimer"
                  bpExtendedTooltip
                  class="bpi__icon-attention attention-icon">
                </div>
              </div>
            }
          </button>
          <div class="border-bottom-gray"></div>
        </div>
      </div>
    }
  </div>
  <div>
    @if (unavailableNetworks?.length > 0) {
      <div class="list-header margin-top"
        >{{ "currently_unavailable" | translate }}
        <div class="border-bottom-gray"></div>
      </div>
    }
    <div class="scrollBar grayed-text">
      @for (network of unavailableNetworks; track network) {
        <div>
          <div class="row-wrapper" role="button">
            <div class="item-wrapper no-cursor">
              <img [src]="network.logo" alt="network logo" class="grayed-out" width="40" />
              <div class="network-name grayed-text">{{ "name_network" | translate: [network.name] }}</div>
            </div>
            <div class="border-bottom-gray"></div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
